<template>
  <div>
    <el-card style="margin: 30px;">
      <div style="display: flex;align-items: center">
        <div>所属城市：</div>
        <el-select style="width: 200px;margin-right: 10px" size="small" v-model="areaCode" placeholder="请选择所属城市" clearable>
          <el-option
              v-for="item in areaData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <div style="margin-left: 10px">展示状态：</div>
        <el-select style="width: 200px;margin-right: 10px" size="small" v-model="deleteStatus" placeholder="请选择展示状态" clearable>
          <el-option
              v-for="item in [{name:'显示',id:'1'},{name:'隐藏',id:'0'}]"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
        <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
        <el-button size="small" type="success" @click="addBtn">新增</el-button>
<!--        <el-button v-if="multipleSelection&&multipleSelection.length" @click="batchDeleteBtn" size="small" type="danger">批量删除</el-button>-->
      </div>

      <el-table
          size="small"
          tooltip-effect="dark"
          ref="multipleTable"
          :data="tableData"
          border
          style="width: 100%;margin-top: 30px"
      >
<!--        <el-table-column-->
<!--            type="selection"-->
<!--            align="center"-->
<!--            width="55">-->
<!--        </el-table-column>-->
        <el-table-column label="开屏图" align="center">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center">
              <el-image
                  style="width: 50px; height: 100px"
                  :src="scope.row.advertisement_url"
                  :preview-src-list="scope.row.advertisement_urlList">
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属城市" width="100" prop="name" align="center"></el-table-column>
        <el-table-column label="跳转地址" prop="link_to" align="center"></el-table-column>
        <el-table-column label="是否展示" width="100" prop="show_second" align="center">
          <template slot-scope="scope" >
            <div>
              <el-tag v-if="scope.row.delete_status == '0'" type="warning">否</el-tag>
              <el-tag v-else type="success">是</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="展示时间(秒)" width="100" prop="show_second" align="center"></el-table-column>
        <el-table-column label="排序" prop="sort" width="100" align="center"></el-table-column>
        <el-table-column label="创建时间" width="180" prop="create_date" align="center"></el-table-column>
        <el-table-column
            align="center"
            label="操作"
            width="300"
        >
          <template slot-scope="scope">
            <el-button size="small" :type="scope.row.delete_status == '0' ? 'primary':'danger'" @click="showBtn(scope.row)">{{ scope.row.delete_status == '0' ? '显示':'隐藏' }}</el-button>
            <el-button size="small" type="success" @click="editBtn(scope.row)">修改</el-button>
<!--            <el-button size="small" type="danger" @click="deleteBtn(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          style="display: flex;justify-content: center;margin-top: 20px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalElements">
      </el-pagination>

    </el-card>


    <a-modal
        :visible="addDialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="500px"
        @cancel="addCancel"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="120px"
      >
        <el-form-item label="开屏图" prop="advertisementUrl">
          <el-upload
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              :action="uploadApiUrl"
              class="avatar-uploader">
            <img v-if="ruleForm.advertisementUrl" :src="ruleForm.advertisementUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>
        <el-form-item label="跳转地址" prop="linkTo">
          <el-input v-model="ruleForm.linkTo" style="width: 300px" size="small" placeholder="请输入跳转地址"></el-input>
        </el-form-item>

        <el-form-item label="所属城市" prop="areaCode">
          <el-select style="width: 300px" size="small" v-model="ruleForm.areaCode" placeholder="请选择所属城市">
            <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示时间(秒)" prop="showSecond">
          <el-input-number v-model="ruleForm.showSecond" size="small" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="ruleForm.sort" size="small" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    删除的弹窗-->
    <a-modal
        title="提示"
        :visible="deleteDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="deleteCancel"
        @ok="deleteSubmit"
    >
      <div>{{simpleDelete?'是否删除该条记录？':'是否删除当前所选中的记录？'}}</div>
    </a-modal>

  </div>
</template>

<script>
import {baseURL} from "@/api/config";

export default {
  data() {
    return {
      areaCode: null,
      deleteStatus: null,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      totalElements: 0,
      addDialogState: false,
      dialogTitle: '',
      uploadApiUrl: '',
      ruleForm: {
        id: null,
        advertisementUrl: '',
        linkTo: '',
        sort: '',
        showSecond: '',
        areaCode: ''
      },
      rules: {
        advertisementUrl: [{required: true, message: "请选择开屏图", trigger: "blur"}],
        linkTo: [{required: true, message: "请输入跳转地址", trigger: "blur"}],
        areaCode: [{required: true, message: "请选择所属城市", trigger: "blur"}],
        showSecond: [{required: true, message: "请输入展示时间(秒)", trigger: "blur"}],
        sort: [{required: true, message: "请输入排序", trigger: "blur"}],
      },
      areaData: [],
      simpleDelete: false,
      deleteId:null,
      deleteDialogState: false,
      multipleSelection:[]
    }
  },
  created() {
    this.uploadApiUrl = baseURL + '/file/uploadAdFile'
    this.getList()
    this.postAxios("/examine/special/getAllOpenUpArea", {}).then(res => {
      if (res && res.success) {
        this.areaData = res.content
      }
    })
  },
  methods: {
    searchBtn() {
      this.getList()
    },
    resetBtn() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.areaCode = null
      this.deleteStatus = null
      this.getList()
    },
    addBtn() {
      this.dialogTitle = '新增广告'
      this.ruleForm = {
        id: null,
        advertisementUrl: '',
        sort: '',
        showSecond: '',
        areaCode: ''
      }
      this.addDialogState = true
    },
    deleteBtn(row){
      this.simpleDelete = true
      this.deleteId = row.id
      this.deleteDialogState = true
    },
    editBtn(row){
      this.dialogTitle = '编辑广告'
      this.ruleForm.id = row.id
      this.ruleForm.advertisementUrl = row.advertisement_url
      this.ruleForm.linkTo = row.link_to
      this.ruleForm.areaCode = row.area_code
      this.ruleForm.showSecond = row.show_second
      this.ruleForm.sort = row.sort
      this.addDialogState = true
    },
    showBtn(row){
      this.postAxios("/ad/kaiping/showStatus", {
        id:row.id,
        deleteStatus: row.delete_status == '0' ? '1':'0'
      }).then(res=>{
        if (res.success){
          this.$message.success(res.message)
          this.getList()
        }
      })
    },
    batchDeleteBtn(){
      this.simpleDelete = false
      this.deleteDialogState = true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteCancel(){
      this.deleteDialogState = false
    },
    deleteSubmit(){
      if (this.simpleDelete){
        //单个删除
        this.postAxios("/ad/kaiping/delete", [
          this.deleteId
        ]).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }else{
        //多个删除
        let ids = []
        this.multipleSelection.forEach((item)=>{
          ids.push(item.id)
        })
        this.postAxios("/ad/kaiping/delete", ids).then(res=>{
          if (res.success){
            this.$message.success(res.message)
            this.deleteId = ''
            this.deleteDialogState = false
            this.getList()
          }
        })
      }
    },
    getList() {
      this.postAxios("/ad/kaiping/list", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          areaCode: this.areaCode ? this.areaCode : null,
          deleteStatus: this.deleteStatus ? this.deleteStatus : null
        }
      }).then(res => {
        if (res && res.success) {
          res.content.forEach((item) => {
            item.advertisement_urlList = []
            if (item.advertisement_url) {
              item.advertisement_urlList.push(item.advertisement_url)
            }
          })
          this.tableData = res.content
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
          this.totalElements = 0
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.success) {
        this.ruleForm.advertisementUrl = res.entity;
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    addCancel() {
      this.addDialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === '新增广告') {
            this.postAxios("/ad/kaiping/insert", this.ruleForm).then(res=>{
              this.$message.success("添加成功!");
              this.addDialogState = false
              this.getList()
            })
          } else {
            this.postAxios("/ad/kaiping/update", this.ruleForm).then(res=>{
              this.$message.success("修改成功!");
              this.addDialogState = false
              this.getList()
            })
          }
        }
      });
    },
  }
}
</script>

<style scoped>

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 200px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 200px;
  line-height: 200px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.avatar {
  width: 100px;
  height: 200px;
  display: block;
}
</style>
